import { SuiteType } from "../Helper";
import { GetAvatarsRequestData, GetSoundEffectRequest } from "../store/Apis/SuitesApps/VideoSuiteApi";

export interface VideoSuiteSample {
  type: number;
  prompt: string;
  images?: string[];
  result: string;
  avatarId?: string;
  voiceId?: string;
}
export interface selectedSettingType{
    selectedSize: string;
    selectedModel: { name: string; version: string };
    selectedMode: string;
    selectedDuration: string;
    selectedStyle: SettingItemObjType;
    seed: number | null;
    generateTime: string;
    creditsNeeded:number;
  };
export interface VideoSuiteInput {
  outputUrl: string;
  inputValue: string;
  inputImage: File | string | null;
  openLockSeed: boolean;
  settings: selectedSettingType;
  isLoading: boolean;
  type: number;
  example: VideoSuiteSample;
}

export const VideoSuiteAppInitStates = {
  VideoGenerator: {
    outputUrl: "",
    inputValue: "",
    inputImage: null,
    openLockSeed: true,
    settings: {
      selectedSize: "",
      selectedModel: {name:"",version:""},
      selectedMode: "",
      selectedDuration: "",
      seed: 0,
      selectedStyle: { description: "", value: "" },
      generateTime: "",
      creditsNeeded:0
    },
    isLoading: false,
    type: 0,
    example: {
      type: 0,
      prompt: "",
      images: [],
      result: "",
    },
  },
  ImageToVideo: {
    outputUrl: "",
    inputValue: "",
    inputImage: null,
    openLockSeed: true,
    settings: {
      selectedSize: "",
      selectedModel: { name: "", version: "" },
      selectedMode: "",
      selectedDuration: "",
      selectedStyle: { description: "", value: "" },
      seed: 0,
      generateTime: "",
      creditsNeeded:0,
    },
    isLoading: false,
    type: 1,
    example: {
      type: 0,
      prompt: "",
      images: [],
      result: "",
    },
  },
  AvatarVideo: {
    outputUrl: "",
    inputValue: "",
    inputImage: null,
    openLockSeed: true,
    settings: {
      selectedSize: "",
      selectedModel: { name: "", version: "" },
      selectedMode: "",
      selectedDuration: "",
      selectedStyle: { description: "", value: "" },
      seed: 0,
      generateTime: "",
      creditsNeeded:0
    },
    isLoading: false,
    type: 2,
    example: {
      type: 0,
      prompt: "",
      images: [],
      result: "",
      avatarId: "",
      voiceId: "",
    },
  },
};
export const VideoSuiteAppsInitial = {
  VideoGenerator: {
    id: "",
    name: "",
    order: 0,
    type: 0,
    icon: null,
  },
  ImageToVideo: {
    id: "",
    name: "",
    order: 0,
    type: 1,
    icon: null,
  },
};
export enum VideoSuiteType {
  VideoGenerator = 0,
  ImageToVideo,
  AvatarVideo,
}
export const VideoSuiteApps = {
  TextToVideo :"Text to Video",
  ImageToVideo: "Image to Video",
  customAvatar: "Custom Avatar",
}
export interface SettingItemObjType {
  description: string;
  value?: string;
}
export interface videoModelType {
  name: string;
  version: string;
}
interface SettingItemContainValueType {
  value: number;
}

export interface VideoSettings {
  name: string;
  version:string;
  generationTime: string;
  modelVideoQualities: SettingItemObjType[];
  modelDurations: SettingItemContainValueType[];
  modelStyles: SettingItemObjType[];
  modelDimensions: SettingItemObjType[];
  seed: number;
}
export interface soundEffectVoiceData{
  id:string;
  url:string;
  category:number;
  fileName:string;
}
export interface VideoSuiteAppInterface {
  videoSettings: VideoSettings[]; 
  activeAppProps: VideoSuiteInput;
  generatedPrompt: string;
  toggleLockSeed: (flag: boolean) => void;
  setInputValue: (value: string) => void;
  handleSetIsLoading: (isLoading: boolean) => void;
  handleModelSettingChanges: (
    name: string,
    value: string | SettingItemObjType |videoModelType
  ) => void;
  IsGeneratePromptLoading: boolean;
  handelGenerateRandomPrompt: () => void;
  handleClearInput: () => void;
  getErrorMessage: (error: any) => void;
  handleVideoWithSoundEffect?:(url:string) => void;
  handelImprovePrompt?: () => void;
  isVideoPromptImproving?: boolean;
  soundEffectData?:soundEffectVoiceData[];
  setSoundEffectParams?: (data: GetSoundEffectRequest) => void;
  isSoundEffectsLoading?: boolean;
}

export interface RequiredForImageInput {
  handleInputImageChange: (Image: File | string | null) => void;
}
export interface VideoAppType {
  id: string;
  name: string;
  order: number;
  type: number;
  icon?: any;
}
export const getVideoSuiteType = (isVideo?:boolean) => {
  return window.location.pathname.includes("video-suite") ||isVideo
    ? SuiteType.Video + ""
    : SuiteType.Image + "";
};

export interface VideoHistoryData {
  id: string;
  output: string;
  appType: string;
  createdAt: string;
}

export interface SettingsData {
  model: string;
  dimension: string;
  style: string;
  videoQuality: string;
  duration: string;
  seed: number | null;
}
export interface PromptData {
  prompt: string;
  attachment: string | null;
}
export interface VideoModalData {
  id: string;
  createdAt: string;
  input: PromptData;
  output: string;
  settings: SettingsData;
  appType: string;
}

export interface AvatarVideoData {
  avatar_id: string;
  avatar_name: string;
  gender: string;
  preview_image_url: string;
}
export interface AvatarVoiceVideoData {
  voice_id: string;
  language: string;
  type: string;
  gender: string;
  preview_audio: string;
  name: string;
}
